import type React from "react";
import {useEffect} from "react";
import {useParams} from "react-router";
import {useStores} from "../../stores";


export const DownloadRedirect: React.FC = () => {
    const {filename} = useParams<{ filename?: string }>();
    const {chatApiStore} = useStores();

    useEffect(() => {
        if (filename) {
            const fetchAndRedirect = async () => {
                const downloadUrl = await chatApiStore.getDownloadUrl(filename);
                window.location.href = downloadUrl;
            };

            fetchAndRedirect();
        }
    }, [filename, chatApiStore]);

    return null;
};